import React from 'react'

interface PlanCardSectionProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> {
  children: React.ReactNode
}

export function PlanCardSection ({ children, ...props }: PlanCardSectionProps) {
  return (
    <div
      {...props}
      className='p-4 flex-grow bg-white group-data-[layout="horizontal"]/plan-card:first:rounded-l-lg group-data-[layout="vertical"]/plan-card:first:rounded-t-lg group-data-[layout="horizontal"]/plan-card:last:rounded-r-lg group-data-[layout="vertical"]/plan-card:last:rounded-b-lg'
    >
      {children}
    </div>
  )
}

PlanCardSection.displayName = 'PlanCard.Section'
